module.exports = __webpack_public_path__ + "static/img/logo.c9f7f1b4.png";